import { memo } from 'react';

import { WorkspaceAgentPillThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPillThumbnail';
import { workspaceAgentPanelPill } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentPanelPillChrome';

export type WorkspaceAgentContextSourceFieldValuePillChipProps = {
  thumbnailUrl: string;
  title: string;
};

/**
 * A resolved brand kit image, drawn from what a caller already holds and asking for nothing. The
 * still and the label are all a kit value has to say about itself — there is no card on either
 * surface yet — which is why this is the whole chip rather than a card's trigger.
 */
export const WorkspaceAgentContextSourceFieldValuePillChip = memo(
  ({ thumbnailUrl, title }: WorkspaceAgentContextSourceFieldValuePillChipProps) => (
    <span className={workspaceAgentPanelPill({ hasLeadingThumbnail: true })} title={title}>
      <WorkspaceAgentPillThumbnail
        testId="WORKSPACE_AGENT_MESSAGE_CONTEXT_SOURCE_FIELD_VALUE_PILL_THUMBNAIL"
        url={thumbnailUrl}
      />
      <span className="truncate whitespace-nowrap">{title}</span>
    </span>
  ),
);

WorkspaceAgentContextSourceFieldValuePillChip.displayName = 'WorkspaceAgentContextSourceFieldValuePillChip';
